<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div id="loader"*ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
<div class="filter-nav overflow-visible ">
  <div class="container d-none d-lg-block">
    <div class="d-flex">
      <div class="d-flex">
        <div class="md-semibold-font text-black  p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}
        </div>
        <div class="mr-2">
          <ng-select [items]="locationsData" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
            groupBy="code" [selectableGroup]="false" [closeOnSelect]="true" placeholder="Select location"
            bindValue="code" [(ngModel)]="selectedLocation" notFoundText="No Items Found" (change)="changeLocation()">
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedLocation?.length}}x{{ 'shipment.Ports' | cxTranslate
                }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
              class="dropdown-ng-template">
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}" type="checkbox"
                  [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
            </ng-template>
          </ng-select>
        </div>

        <div class="mr-2">
          <ng-select [items]="Materialsdata" [multiple]="true" [clearable]="false" bindLabel="Materialsdata"
            dropdownPosition="bottom" groupBy="Materialsdata" [selectableGroup]="false" [closeOnSelect]="true"
            placeholder="Select material" bindValue="Materialsdata" [(ngModel)]="selectedMaterial" notFoundText="No Items Found"
            (change)="changeMaterial()">
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedMaterial?.length}}x {{'shipment.statusselected' |
                cxTranslate}}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" 
            class="dropdown-ng-template">
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input *ngIf="item!==undefined && item!==''" id="{{item}}" type="checkbox"
                [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item}}</span>
            </ng-template>
          </ng-select>
        </div>
        <div *ngIf="showClear">
          <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter()">{{
            'home.productHeader.ClearFilter' | cxTranslate }}</button>
        </div>
      </div>
      <div class="ml-auto d-flex">
        <!--search function desktop-->
        <div class="d-flex align-items-center mr-2 search-section-col">
          <div class="search-section-div">
            <div class="input-group d-flex align-items-center">
              <input class="form-control form-control-lg border fs-14 rounded-pill input-field" type="search"
                (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" id="consign-search-input" (input)="search()"
                placeholder="Search material">
              <span class="input-group-append">
                <button name='searchbuttondesktop'
                  class="btn btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                  type="button">
                  <i class="fa fa-search pe-none"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
    <div class="container hidden-xs-filter-bar">
    <div class="row">
      <div class="w-100">
        <div class="filter-select-div-mobile pl-4">
          <div class="input-group p-2">
            <input class="form-control from-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttonfilter' class="
                      btn
                      rounded-pill
                      border-0
                      input-field
                      border-start-0 border-bottom-0 border
                      ms-n5
                    " type="button">
                <i class="fa fa-search mobbar"></i>
              </button>
              <div class='hidden-xs-filter-bar vertical ml-4'></div>
              <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                  *ngIf='length'>{{length}}</sup>
                <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                  cxTranslate }}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="background">
      <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
        class="hidden-xs-filter-bar sidebar">
        <div class='  d-flex flex-row justify-content-between p-3 border sticky'>
          <div class="fs-24 md-semibold-font pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt="">
          </div>
        </div>
		<div class="scrollbar">
		<div class="d-flex md-semibold-font  pl-3 pt-3 pb-2">location:</div>
		<div *ngFor="let statusData of locationsData; let i=index" class=" ml-5  d-flex line-height ">
            <label class="scroll-checkbox" *ngIf="statusData.name!==undefined && statusData.name!==''">
			 <input type="checkbox" [(ngModel)]="statusData.selected" [value]="statusData.code"
                [checked]="statusData.selected"  (change)="onCheckboxlocationChange($event , statusData.code)"/>
            {{statusData.name }}			
            </label>
        </div>
		<div>
                  <div>
                <div class="d-flex strong  pl-4 pt-3 pb-2">{{ 'home.contracts.products' | cxTranslate }} :</div>
                <div *ngFor="let productData of MaterialsData; let i=index" class="ml-5  d-flex line-height ">
                    <label *ngIf="productData!==undefined && productData!==''">                                                    
            <input type="checkbox" [(ngModel)]="productData.selected" [value]="productData.name"
              [checked]="productData.selected" (change)="onCheckboxproductChange($event , productData.name)" />
            {{productData.name}}
          </label>
                </div>
            </div>

		</div>
	</div>
        <div class="sticky-bottom p-4 border-top">
          <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'
            |
            cxTranslate}}</button>
          <button class='btn btn-block' (click)="clearFilterMobile($event)">{{ 'home.contracts.clearFilter' |
            cxTranslate}}</button>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="container">
  <div class="row d-flex justify-content-between px-2 pt-4">
    <div class="col-lg-3 tabDiv">
      <nav class="product-tab ">
        <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist">
          <div class="tab-bar">{{ 'home.productHeader.Browseby' | cxTranslate }}:</div>
          <div class="nav-item nav-link active tab-bar strong" [class.active]="activeTab === 'location'"
            id="nav-profile-tab" data-toggle="tab" role="tab" aria-controls="nav-profile" aria-selected="true"
            (click)="changeTab('location')"> Location
          </div>
          <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'material'" id="nav-home-tab"
            data-toggle="tab" role="tab" aria-controls="nav-home" aria-selected="false" (click)="changeTab('material')">
            Material
          </div>
        </div>
      </nav>
    </div>
    <div class=" mobdisplay gird-div display-top mt-n1 d-none d-md-block d-lg-block-filter-bar">
      <span class="grid-icon ml-3">Display as: &nbsp;
        <img class="grid-icon" title="grid" [src]='gridSrc' (click)="viewGrid()">
        <img class="list-icon" title="list" [src]='listSrc' (click)=" viewList()">

      </span>
    </div>

  </div>
  <div class="border-bottom"></div>
</div>
<!--for Location-->
<div class="container" *ngIf="grid==true">
  <div *ngIf="listData?.length===0 && !enableLoader" class="text-secondary strong mt-4 text-center">No results</div>
  <div *ngIf="listData?.length>0">
  <form [formGroup]="consignmentForm">
    <div formArrayName="listData">
  <div *ngFor="let group of listData?.controls; let i=index " [formGroupName]="i">
    <h3 class="strong mt-5">
      {{group.get('key')?.value}}</h3>
      <div *ngIf="activeTab === 'location'">
      <div>
        {{group.get('value')?.value[0]?.address?.houseNum}}
        {{group.get('value')?.value[0]?.address?.street}}
        {{group.get('value')?.value[0]?.address?.city}}/
        {{group.get('value')?.value[0]?.address?.state}}
        {{group.get('value')?.value[0]?.address?.country}}
        {{group.get('value')?.value[0]?.address?.pin}}
      </div>
      </div>
    <div class="carousel-controls" *ngIf="getValues(i)?.length>3">
    <i (click)="left(i)" class="fa fa-lg fa-chevron-left text-primary pe-auto"
    [ngClass]="{'text-primary':canScrollLeft[i],'text-secondary':!canScrollLeft[i]}"></i>
    <i (click)="right(i)" class="fa fa-lg fa-chevron-right text-primary pe-auto"
    [ngClass]="{'text-primary':canScrollRight[i],'text-secondary pe-none':!canScrollRight[i]}"></i>
  </div>
  <div class="carousel d-flex flex-row flex-nowrap overflow-auto" id="'carousel'+i"  #carousel formArrayName="value">
      <div class="card h-100 border-radius-05 me-3 width mt-4" *ngFor="let item of getValues(i)?.controls; let j= index" [formGroupName]="j">
      <div style="background-color:#0A6CB4;" class="card-header borderRadius pb-1">
      </div>
      <div class="card-body d-flex flex-column justfy-content-between">
        <div>
            <h4 class=" fw-bold text-wrap min-title-height">
              <span *ngIf="activeTab === 'location'">{{item?.get('materialName')?.value}}</span>
            <span *ngIf="activeTab === 'material'">{{item?.get('location')?.value}}</span>
            </h4>
                              <span *ngIf="activeTab === 'material'">
                                <span>
                                  {{item?.get('address').get('houseNum')?.value}}
                                  {{item?.get('address').get('street')?.value}}
                                  {{item?.get('address').get('city')?.value}}/
                                  {{item?.get('address').get('state')?.value}}
                                  {{item?.get('address').get('country')?.value}}
                                  {{item?.get('address').get('pin')?.value}}
                                </span>
                              </span>

            <div class="mt-2">Stock available: {{item?.get('stockAvailable')?.value}}</div>
          <div class="row">
            <div class="col-md-6 mt-4">
              <div class=" text-secondary mb-1">Base price (per ST)</div>
                            <div class="input-group">
                <div class="input-group-prepend">
                 <span class="input-group-text">$</span>
                 </div>
                <input type="text"  appPositiveNegativeDecimalNumber
                                [beforeDecimal]="5" [afterDecimal]="2" [numberType]="'positive'"
                                 formControlName="basePrice" class="form-control bold rounded-0">
                                 <div class="error-space">
                 <p *ngIf="item.get('basePrice')?.invalid && item.get('quantity')?.touched" class="text-danger small">
                 Please Enter basePrice
                 </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 mt-4">
              <div class=" text-secondary mb-1">Quantity (ST)</div>
               <div>
                <input type="text" appPositiveNegativeDecimalNumber
                                [beforeDecimal]="5" [afterDecimal]="item?.get('allowedDecimalQty')?.value" [numberType]="'positive'"
                                formControlName="quantity"  class="form-control bold rounded-0">
              </div> 
              <div class="error-space">
                <p class="text-danger bold small" *ngIf="item?.get('quantity')?.value>item.get('stockAvailable')?.value">Quantity cannot
                  be greater than stock available
                </p>
                <p class="text-danger bold small" 
                *ngIf="item.get('quantity')?.invalid && item.get('quantity')?.touched"
                >Quantity is required
                </p>
              </div>
            </div>
          </div>
          <button class="btn btn-primary w-100 mt-5" *ngIf="item.get('hasPricePeriod')?.value==true" (click)="placebid(item)">Place order</button>
           <button class="btn btn-color  mt-5 w-100" *ngIf="item.get('hasPricePeriod')?.value==false"
           [disabled]="true" >contact BHP to place an order</button>

        </div>
      </div>
      </div>
  </div>
</div>
</div>
</form>
</div>
</div>
<!--for location list view-->
    <div class="container" *ngIf=" list==true">
      <div *ngIf="listData?.length===0 && !enableLoader" class="text-secondary strong text-center">No results</div>
      <div *ngIf="listData?.length>0">
    
        <form [formGroup]="consignmentForm">
          <div formArrayName="listData">
            <div class="" *ngFor="let group of listData?.controls; let i=index " [formGroupName]="i">
              <h3 class="strong mt-5">{{group?.get('key')?.value}}</h3>
                    <div *ngIf="activeTab === 'location'">
                      <div>
                        {{group.get('value')?.value[0]?.address?.houseNum}}
                        {{group.get('value')?.value[0]?.address?.street}}
                        {{group.get('value')?.value[0]?.address?.city}}/
                        {{group.get('value')?.value[0]?.address?.state}}
                        {{group.get('value')?.value[0]?.address?.country}}
                        {{group.get('value')?.value[0]?.address?.pin}}
                      </div>
                    </div>
              <div class="col-md-12 col-lg-12 " formArrayName="value">
                <div class="card mt-4 mb-4 card-border border-radius-05"
                  *ngFor="let item of getValues(i)?.controls; let j= index" [formGroupName]="j">
                  <div style="background-color:#0A6CB4;" class="card-header borderRadius pb-1"></div>
                  <div class="card-body  ">
                    <div class='row py-2 text-break'>
                      <div class="col-md-5">
                          <span *ngIf="activeTab === 'location'">{{item?.get('materialName')?.value}}</span>
                          <span *ngIf="activeTab === 'material'">{{item?.get('location')?.value}}</span>
                                                        <div *ngIf="activeTab === 'material'">
                                                          <span>
                                                            {{item?.get('address').get('houseNum')?.value}}
                                                            {{item?.get('address').get('street')?.value}}
                                                            {{item?.get('address').get('city')?.value}}/
                                                            {{item?.get('address').get('state')?.value}}
                                                            {{item?.get('address').get('country')?.value}}
                                                            {{item?.get('address').get('pin')?.value}}
                                                          </span>
                                                        </div>
                        <div class=" text-secondary">Stock available: {{item?.get('stockAvailable')?.value}}</div>
                      </div>
                      <div class=" col-md-2 text-nowrap">
                        <div class=" text-secondary">Base price (per ST)</div>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text"  appPositiveNegativeDecimalNumber
                                [beforeDecimal]="5" [afterDecimal]="2" [numberType]="'positive'" formControlName="basePrice" class="form-control bold rounded-0">
                        </div>
                      </div>
                      <div class=" col-md-2">
                        <div class=" text-secondary">Quantity (ST)</div>
                         <div>
                <input type="text" appPositiveNegativeDecimalNumber
                                [beforeDecimal]="5" [afterDecimal]="item?.get('allowedDecimalQty')?.value" [numberType]="'positive'"
                                formControlName="quantity"  class="form-control bold rounded-0">
              </div> 
                      </div>  
                      <div class=" col-md-2">
                        <div>
                          <button class="btn btn-primary w-100 mt-2"  (click)="placebid(item)"
                            *ngIf="item.get('hasPricePeriod')?.value">Place order</button>
                          <button class="btn btn-color w-100 mt-4 text-black"
                            *ngIf="!item.get('hasPricePeriod')?.value"
                            [disabled]>Contact BHP to Place an Order</button>
    
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

</div>